export default class PracticeGroupMember {
  id!: number
  practice_group_id!: number
  practice_group_name!: string
  user_id!: number
  user_email!: string
  user_name!: string
}